import React from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import { CalendarOptions } from '@fullcalendar/core';
import './YearCalendar.css'; // Import the CSS file for custom styles
import multiMonthPlugin from '@fullcalendar/multimonth'
import { Tooltip } from 'react-tooltip'

interface YearCalendarProps {
    events: { title: string; start: string; end?: string; tooltip: string; }[];
} 

const YearCalendar: React.FC<YearCalendarProps> = ({ events }) => {
  const calendarOptions: CalendarOptions = {
    plugins: [multiMonthPlugin],
    initialView: 'multiMonthYear',
    initialDate: new Date(),
    // views: {
    //   multiMonthYear: {
    //     type: 'dayGrid',
    //     duration: { months: 12 },
    //     buttonText: 'Year',
    //   },
    // },
    // headerToolbar: {
    //   left: 'prev,next today',
    //   center: 'title',
    //   right: 'multiMonthYear,dayGridMonth,dayGridWeek,dayGridDay',
    // },
    events: events,
    // eventContent: (eventInfo) => (
    //     <>
    //       <div data-tooltip-id="my-tooltip" data-tip={eventInfo.event.extendedProps.tooltip}>
    //         {eventInfo.event.title}
    //       </div>
    //       <Tooltip id="my-tooltip" />
    //     </>
    //   ),
  };

  return (
    <div className="year-calendar">
      <FullCalendar {...calendarOptions} />
    </div>
  );
};

export default YearCalendar;